<div class="weekly-report journal">
  <app-loading-spinner *ngIf="isLoading"></app-loading-spinner>
  <div class="weekly-report-header">
    <button class="btn btn-close-weekly-report" (click)="onClose()">
      <span class="icon-wrap"
        ><fa-icon [icon]="['fas', 'xmark']" [fixedWidth]="true"></fa-icon
      ></span>
    </button>
    <h1>My Journal</h1>
    <button class="btn btn-add-weekly-report" (click)="onAddForm()">
      <span class="icon-wrap"
        ><fa-icon [icon]="['fas', 'circle-plus']" [fixedWidth]="true"></fa-icon
      ></span>
    </button>
  </div>
  <div class="weekly-report-body">
    <nav class="weekly-report-nav">
      <div class="weekly-report-nav-shadow"></div>
      <ul>
        <li
          [ngClass]="{ active: pageId == 'prepWell' }"
          *ngIf="pages.indexOf('prepWell') !== -1"
        >
          <button
            type="button"
            class="btn w-100"
            title="Prep Steps"
            (click)="goToPage('prepWell')"
            aria-label="Prep Well"
          >
            <span class="icon-wrap">
              <img
                src="/assets/img/device-prepwell-dark.svg"
                alt="The Prepwell logo"
              />
            </span>
          </button>
        </li>
        <li
          [ngClass]="{ active: pageId == 'prepSteps' }"
          *ngIf="pages.indexOf('prepSteps') !== -1"
        >
          <button
            type="button"
            class="btn w-100"
            title="Prep Steps"
            (click)="goToPage('prepSteps')"
            aria-label="Prep Steps"
          >
            <span class="icon-wrap"
              ><fa-icon
                [icon]="['fas', 'walking']"
                [fixedWidth]="true"
              ></fa-icon
            ></span>
          </button>
        </li>
        <li
          [ngClass]="{ active: pageId == 'prepFit' }"
          *ngIf="pages.indexOf('prepFit') !== -1"
        >
          <button
            type="button"
            class="btn w-100"
            title="Prep Fit"
            (click)="goToPage('prepFit')"
            aria-label="Prep Fit"
          >
            <span class="icon-wrap"
              ><fa-icon
                [icon]="['fas', 'running']"
                [fixedWidth]="true"
              ></fa-icon
            ></span>
          </button>
        </li>
        <li
          [ngClass]="{ active: pageId == 'prepStrong' }"
          *ngIf="pages.indexOf('prepStrong') !== -1"
        >
          <button
            type="button"
            class="btn w-100"
            title="Prep Strong"
            (click)="goToPage('prepStrong')"
            aria-label="Prep Strong"
          >
            <span class="icon-wrap"
              ><fa-icon
                [icon]="$any(['fac', 'lunge'])"
                [fixedWidth]="true"
              ></fa-icon
            ></span>
          </button>
        </li>
        <li
          [ngClass]="{ active: pageId == 'breatheWell' }"
          *ngIf="pages.indexOf('breatheWell') !== -1"
        >
          <button
            type="button"
            class="btn w-100"
            title="Breathe Well"
            (click)="goToPage('breatheWell')"
          >
            <span class="icon-wrap"
              ><fa-icon [icon]="['fas', 'lungs']" [fixedWidth]="true"></fa-icon
            ></span>
          </button>
        </li>
        <li
          [ngClass]="{ active: pageId == 'eatWell' }"
          *ngIf="pages.indexOf('eatWell') !== -1"
        >
          <button
            type="button"
            class="btn w-100"
            title="Eat Well"
            (click)="goToPage('eatWell')"
          >
            <span class="icon-wrap"
              ><fa-icon
                [icon]="['fas', 'cutlery']"
                [fixedWidth]="true"
              ></fa-icon
            ></span>
          </button>
        </li>
        <li
          [ngClass]="{ active: pageId == 'drinkingGuide' }"
          *ngIf="pages.indexOf('drinkingGuide') !== -1"
        >
          <button
            type="button"
            class="btn w-100"
            title="Drinking Guide"
            (click)="goToPage('drinkingGuide')"
          >
            <span class="icon-wrap"
              ><fa-icon
                [icon]="['fas', 'martini-glass']"
                [fixedWidth]="true"
              ></fa-icon
            ></span>
          </button>
        </li>
        <li
          [ngClass]="{ active: pageId == 'iQuit' }"
          *ngIf="pages.indexOf('iQuit') !== -1"
        >
          <button
            class="btn w-100"
            title="I-Quit"
            (click)="goToPage('iQuit')"
            type="button"
          >
            <span class="icon-wrap"
              ><fa-icon
                [icon]="['far', 'smoking-ban']"
                [fixedWidth]="true"
              ></fa-icon
            ></span>
          </button>
        </li>
        <li
          [ngClass]="{ active: pageId == 'sleepWell' }"
          *ngIf="pages.indexOf('sleepWell') !== -1"
        >
          <button
            type="button"
            class="btn w-100"
            title="Sleep Well"
            (click)="goToPage('sleepWell')"
          >
            <span class="icon-wrap"
              ><fa-icon
                [icon]="['far', 'face-sleeping']"
                [fixedWidth]="true"
              ></fa-icon
            ></span>
          </button>
        </li>
        <li
          [ngClass]="{ active: pageId == 'feelWell' }"
          *ngIf="pages.indexOf('feelWell') !== -1"
        >
          <button
            type="button"
            class="btn w-100"
            title="Feel Well"
            (click)="goToPage('feelWell')"
          >
            <span class="icon-wrap"
              ><fa-icon
                [icon]="['far', 'face-smile-relaxed']"
                [fixedWidth]="true"
              ></fa-icon
            ></span>
          </button>
        </li>
      </ul>
    </nav>

    <ng-container>
      <!-- Add Form -->
      <div class="weekly-report-page" *ngIf="addEntry">
        <h2 class="weekly-report-page-title mt-5">New Entry</h2>

        <form name="entryForm" #entryForm="ngForm" class="standard-form mt-4">
          <div class="row">
            <div class="form-group text-center">
              <select
                name="area"
                id="area"
                class="form-select"
                [ngModel]="pageId"
                #area="ngModel"
                required
              >
                <option *ngFor="let area of areas" [value]="area.id">
                  {{ area.label }}
                </option>
              </select>
              <div class="alert alert-danger" *ngIf="!area.valid && submitted">
                {{ "Please select an area above" }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="form-group">
                <label for="notes" class="visually-hidden"
                  >Add your entry here
                </label>
                <textarea
                  [ngModel]
                  #notes="ngModel"
                  class="form-control"
                  type="radio"
                  name="notes"
                  id="notes"
                  required
                  placeholder="Add your entry here"
                  rows="5"
                ></textarea>
                <div
                  class="alert alert-danger"
                  *ngIf="!notes.valid && submitted"
                >
                  {{ "Please enter a comment above" }}
                </div>
              </div>

              <div class="form-group text-center">
                <label>&nbsp;</label>
                <div>
                  <button
                    (click)="onSubmitForm()"
                    class="btn btn-primary w-100"
                  >
                    Submit Entry
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>

      <!-- edit form -->
      <div class="weekly-report-page" *ngIf="editEntry">
        <h2 class="weekly-report-page-title mt-5">Edit Entry</h2>

        <form
          name="editForm"
          #editForm="ngForm"
          class="standard-form mt-4"
        >
          <div class="row">
            <div class="form-group text-center">
              <select
                name="area"
                id="area"
                class="form-select"
                [ngModel]="editEntry.area"
                #area="ngModel"
                required
              >
                <option *ngFor="let area of areas" [value]="area.id">
                  {{ area.label }}
                </option>
              </select>
              <div class="alert alert-danger" *ngIf="!area.valid && submitted">
                {{ "Please select an area above" }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="form-group">
                <label for="notes" class="visually-hidden"
                  >Add your entry here
                </label>
                <textarea
                  [ngModel]="editEntry.notes"
                  #notes="ngModel"
                  class="form-control"
                  type="radio"
                  name="notes"
                  id="notes"
                  required
                  placeholder="Add your entry here"
                  rows="5"
                ></textarea>
                <div
                  class="alert alert-danger"
                  *ngIf="!notes.valid && submitted"
                >
                  {{ "Please enter a comment above" }}
                </div>
              </div>

              <div class="form-group text-center">
                <label>&nbsp;</label>
                <div>
                  <button
                    (click)="onSubmitEditForm()"
                    class="btn btn-primary w-100"
                  >
                    Update Entry
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>

        <button class="btn w-100 btn-danger mt-4" (click)="onDelete(editEntry)">Delete</button>
      </div>

      <ng-container *ngFor="let area of areas">
        <div class="weekly-report-page" *ngIf="pageId == area.id && !addEntry && !editEntry">
          <h2 class="weekly-report-page-title mt-5">{{ area.label }}</h2>

          <div *ngFor="let note of getNotes(area.id)" class="journal-entry">
            <button class="btn journal-entry-edit" (click)="onEditEntry(note)">
              <span class="icon-wrap more-link duo-primary-dark"
                ><fa-icon [icon]="['fad', 'circle-chevron-right']"></fa-icon
              ></span>
            </button>
            <div class="journal-entry-date">
              {{ note.created | customDate : "ddd Do MMMM | h:mm:ss a" }}
            </div>
            <div class="journal-entry-entry">{{ note.notes }}</div>
          </div>
          <p *ngIf="getNotes(area.id).length == 0">
            There are no journal entries in this section
          </p>
        </div>
      </ng-container>
    </ng-container>
  </div>
</div>
